import React from "react";
import '../Styles/index.sass';
import '../Images/Home/CC_PrimaryLogo_Colour.png';
import { Container, Row, Col } from 'react-grid-system';
import FooterLogo from '../Images/Home/CC_PrimaryLogo_Colour.svg';

function Footer() {
  return (
    <div className="footerOptions">
      <Container>
        <Row className="">
          <Col lg={12}>
            <hr></hr>
          </Col>
        </Row>
        <br></br>
        <br></br>
        <br></br>
        <Row>
          <Col lg={2}>
            <a href="">Hire a Professional</a>
          </Col>
          <Col lg={2}>
            <a href="">Find a Job</a>
          </Col>
          <Col lg={4}>
            <img className="footerLogo" src={FooterLogo} alt='Company Logo' />
          </Col>
          <Col lg={2}>
            <a href="/about">About</a>
          </Col>
          <Col lg={2}>
            <a href="">Terms & Conditions</a>
            </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Footer;